/* eslint-disable no-unused-vars */

import _ from 'lodash';
import moment from 'moment';

import { removeUnavailableTreeData } from '@components/tree-component';
import { siteSearchData } from '@utilities/site-search';
import { cleanString } from '@utilities/attachments';
import {
  createAtOrSyncedDateFilter,
  dueDateFilter,
  scheduledDateFilter
} from '@utilities/date-filters';

import { sortFilterTags } from '@utilities/filter-is-changed';

export const filterSites = ({
  filters,
  sites,
  SelectedFilter,
  areaHierarchyTreeDataMap,
  siteTypeQuery,
  templates,
  runs,
  selectedSiteIdForMapView
}) => {
  const {
    area,
    proximity,
    siteType,
    siteStatus,
    searched = '',
    taskType,
    taskStatus,
    priority,
    workOrderPriority,
    assign,
    scheduledDate,
    download,
    dueDate: filterDueDate,
    recurringTemplate,
    workOrderType,
    createdAt,
    inspectionType,
    inspectionRun,
    syncedDate: syncedDateFilter,
    checkRecurrancePriority,
    checkType,
    hseEventCategory,
    equipmentCategory = {
      value: []
    },
    equipmentType = {
      value: []
    }
  } = filters;

  let sitesSiteTypeData = {},
    sitesSiteStatusData = {},
    sitesAreaHierarchyTreeData = {},
    sitesWorkOrderPriorityDataMap = {},
    equipmentsEquipmentCategoryData = {},
    equipmentsEquipmentTypeData = {};

  const selectedEquipmentCategoryMap = equipmentCategory?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const selectedEquipmentTypeMap = equipmentType?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const hseEventCategoryMap = hseEventCategory?.value?.reduce((acc, curr) => {
    acc[curr?.toString()] = true;
    return acc;
  }, {});

  const inspectionTypeMap = filters?.inspectionType?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const selectedWorkOrderRecurringTemplateMap = recurringTemplate?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const checkTypeMap = checkType?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const workOrderTypeMap = workOrderType?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const selectedAreaMap = area?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const selectedSiteTypeMap = siteType?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const selectedSiteStatusMap = siteStatus?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const selectedRecurrancePriority = checkRecurrancePriority?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const inspectionRunMap = inspectionRun?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const selectedTaskType = taskType?.value?.includes('All')
    ? {
        'Work Order': true,
        'Work Request': true,
        Inspection: true,
        Check: true,
        HSE: true,
        'New or edited asset': true
      }
    : taskType.value.reduce((acc, curr) => {
        acc[
          curr === 'Work orders'
            ? 'Work Order'
            : curr === 'Work requests'
            ? 'Work Request'
            : curr === 'Inspections'
            ? 'Inspection'
            : curr === 'HSE events'
            ? 'HSE'
            : curr === 'Check'
            ? 'Check'
            : curr === 'New or edited asset'
            ? 'New or edited asset'
            : 'Work Order'
        ] = true;
        return acc;
      }, {});

  const selectedTaskStatus = taskStatus.value.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const selectedWorkOrderPriority = workOrderPriority?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});
  const selectedPriority = priority?.value?.reduce((acc, curr) => {
    acc[curr] = true;
    return acc;
  }, {});

  const templatesMap = templates?.length
    ? templates.reduce((acc, curr) => {
        acc[curr] = true;
        return acc;
      }, {})
    : {};

  const runsMap = runs?.length
    ? runs?.reduce((acc, curr) => {
        acc[curr] = true;
        return acc;
      }, {})
    : {};

  let filtered = sites
    .filter((props) => {
      const {
        distance,
        status,
        siteType: type,
        areaHierarchy,
        allTasksForSite,
        hseEvents,
        alNewWorkOrderListSyncedAndInprogress
      } = props;

      sitesSiteTypeData[type] = true;
      sitesSiteStatusData[status] = true;
      sitesAreaHierarchyTreeData[areaHierarchy] = true;
      if (props?.equipmentsEquipmentCategoryData) {
        equipmentsEquipmentCategoryData = {
          ...equipmentsEquipmentCategoryData,
          ...props.equipmentsEquipmentCategoryData
        };
      }
      if (props?.equipmentsEquipmentTypeData) {
        equipmentsEquipmentTypeData = {
          ...equipmentsEquipmentTypeData,
          ...props.equipmentsEquipmentTypeData
        };
      }
      if (!_.isEmpty(searched)) {
        if (!siteSearchData({ inputValue: searched, site: props })) return false;
      }
      const dueCon = _.isArray(filterDueDate.value) ? !filterDueDate.value.includes('') : true;
      const scheduleCon = _.isArray(scheduledDate.value) ? !scheduledDate.value.includes('') : true;
      const createAtCon = _.isArray(createdAt?.value) ? !createdAt?.value.includes('') : true;
      const syncedDateCon = _.isArray(syncedDateFilter?.value)
        ? !syncedDateFilter?.value.includes('')
        : true;

      if (
        ['NewOrEditAsset', 'newOrEditAssets'].includes(siteTypeQuery) &&
        equipmentCategory?.value?.length > 0 &&
        !props?.equipmentListForTestingFilter?.some(
          (x) => x.equipmentCategory && selectedEquipmentCategoryMap[x.equipmentCategory]
        )
      )
        return false;

      if (
        ['NewOrEditAsset', 'newOrEditAssets'].includes(siteTypeQuery) &&
        equipmentType?.value?.length > 0 &&
        !props?.equipmentListForTestingFilter?.some(
          (x) => x.equipmentType && selectedEquipmentTypeMap[x.equipmentType]
        )
      )
        return false;

      if (
        recurringTemplate?.value?.length > 0 &&
        !allTasksForSite.some(
          (x) => selectedWorkOrderRecurringTemplateMap[`${x.rtNumber} - ${x.rtName}`]
        )
      )
        return false;

      if (
        hseEventCategory?.value?.length > 0 &&
        !hseEvents?.some((x) => hseEventCategoryMap[x.inspectionType?.toString()])
      ) {
        return false;
      }

      if (
        inspectionType?.value?.length > 0 &&
        !allTasksForSite.some((x) => inspectionTypeMap[x.inspectionFormId])
      )
        return false;

      if (
        inspectionRun?.value.length > 0 &&
        !allTasksForSite.some((x) => inspectionRunMap[`${x.runNumber} - ${x.RunName}`?.trim()])
      )
        return false;

      if (
        checkType?.value.length > 0 &&
        !allTasksForSite.some((x) => checkTypeMap[x.inspectionTypeId])
      )
        return false;

      if (
        workOrderType?.value?.length > 0 &&
        ![...alNewWorkOrderListSyncedAndInprogress, ...allTasksForSite].some(
          (x) => workOrderTypeMap[x?.typeId]
        )
      )
        return false;

      if (
        siteTypeQuery === 'Work Order' &&
        !(
          allTasksForSite.some((x) => x.type === 'Work Order') ||
          alNewWorkOrderListSyncedAndInprogress.some((x) => x.type === 'Work Order')
        )
      )
        return false;
      if (siteTypeQuery === 'Inspection' && !allTasksForSite.some((x) => x.type === 'Inspection'))
        return false;
      if (siteTypeQuery === 'Check' && !allTasksForSite.some((x) => x.type === 'Check'))
        return false;

      if (siteTypeQuery === 'hseEvents' && !props?.hseEvents.some((x) => x.type === 'HSE'))
        return false;

      if (
        siteTypeQuery === 'Work Request' &&
        !props?.allWorkRequestListSyncedAndInprogress.some(
          (x) => x.newWorkRequest || x?.entityType === 'WorkRequest'
        )
      )
        return false;

      if (siteTypeQuery === 'NewOrEditAsset' && !props?.equipmentEditList.length > 0) {
        return false;
      }

      if (templates?.length > 0 && !allTasksForSite.some((x) => templatesMap[x.rtNumber]))
        return false;

      if (runs?.length > 0 && !allTasksForSite.some((x) => runsMap[x.runNumber])) return false;

      if (
        taskType.value.length > 0 &&
        !(
          allTasksForSite.some(
            (x) => selectedTaskType[x?.newWorkRequest ? 'Work Request' : x.type]
          ) ||
          props?.hseEvents.some((x) => selectedTaskType[x.type]) ||
          props?.allWorkRequestListSyncedAndInprogress.some((x) => selectedTaskType[x.type]) ||
          props?.equipmentEditList.some((x) => selectedTaskType[x.type])
        )
      )
        return false;
      if (
        taskStatus.value.length > 0 &&
        !(
          allTasksForSite.some((x) => selectedTaskStatus[x.status]) ||
          props?.allWorkRequestListSyncedAndInprogress?.some((x) => selectedTaskStatus[x.status]) ||
          props?.equipmentEditList?.some((x) => selectedTaskStatus[x.equipmentEditingStatus])
        )
      )
        return false;

      if (
        allTasksForSite.some((x) => x.type === 'Checks') &&
        priority.value.length > 0 &&
        !allTasksForSite.some((x) => selectedPriority[x.priority])
      )
        return false;

      allTasksForSite?.map((x) => {
        if (!sitesWorkOrderPriorityDataMap[x.priority])
          sitesWorkOrderPriorityDataMap[x.priority] = true;
      });

      if (
        workOrderPriority.value.length > 0 &&
        !allTasksForSite.some(
          (x) => x.type === 'Work Order' && selectedWorkOrderPriority[x.priority]
        )
      )
        return false;

      if (
        checkRecurrancePriority?.value?.length > 0 &&
        !allTasksForSite.some(
          (x) => x.type === 'Check' && selectedRecurrancePriority[x.recurrencePriorityId]
        )
      )
        return false;

      if (
        assign?.value?.length > 0 &&
        !allTasksForSite.some((y) =>
          assign.value.some((r) => y.customAssignedTaskValue.includes(r))
        )
      )
        return false;

      if (
        !_.isEmpty(filterDueDate.value) &&
        dueCon &&
        !allTasksForSite.some((x) =>
          dueDateFilter({
            taskDueDate: x.dueDate ? x?.dueDate : x?.due ? x?.due : x?.nextDue,
            dueDateFilter: filterDueDate
          })
        )
      )
        return false;

      if (
        !_.isEmpty(scheduledDate.value) &&
        scheduleCon &&
        !allTasksForSite.some((x) =>
          scheduledDateFilter({
            startDate: x.startDate || x?.NextScheduled,
            syncedDate: x.syncedDate,
            dueDateFilter: scheduledDate
          })
        )
      )
        return false;

      if (
        !_.isEmpty(createdAt?.value) &&
        createAtCon &&
        !allTasksForSite.some((x) =>
          createAtOrSyncedDateFilter({
            dateForFilter: x?.createdDate,
            filterSelectedDate: createdAt
          })
        )
      )
        return false;

      if (
        !_.isEmpty(syncedDateFilter?.value) &&
        syncedDateCon &&
        !(
          allTasksForSite.some((x) =>
            createAtOrSyncedDateFilter({
              dateForFilter: x.syncedDate,
              filterSelectedDate: syncedDateFilter
            })
          ) ||
          props?.allWorkRequestListSyncedAndInprogress.some((x) =>
            createAtOrSyncedDateFilter({
              dateForFilter: x.syncedDate,
              filterSelectedDate: syncedDateFilter
            })
          )
        )
      )
        return false;

      if (area.value.length > 0 && !selectedAreaMap[areaHierarchy]) return false;
      if (siteType.value.length > 0 && !selectedSiteTypeMap[type]) return false;
      if (siteStatus.value.length > 0 && !selectedSiteStatusMap[status]) return false;

      if (proximity.value) {
        if (!distance) return false;
        if (distance >= proximity.value) return false;
      }

      return true;
    })
    .sort((a, b) => {
      switch (SelectedFilter[0]) {
        case 'DUE':
          return dueDateSort(a, b);
        case 'DISTANCE':
          return distanceFilter(a, b);
        case 'A-Z':
          return a.name.localeCompare(b.name);
        case '# TASKS':
          return tasksFilter(a, b);
      }
    })
    ?.map((a, ind) => {
      const dataPoints = a?.dataPointsForSearch || [];
      const cleanInput = a?.dataPointsForSearch?.length > 0 ? cleanString(searched) : '';

      let newDataPointsList = dataPoints.filter((item) => {
        let titleAndValueCombineObject = `${item.title} : ${item.value}`;
        return cleanString(String(titleAndValueCombineObject)).includes(cleanInput);
      });

      return {
        ...a,
        siteActualIndex: ind,
        dataPoints: searched ? [...a.dataPoints, ...newDataPointsList] : a?.dataPoints
      };
    });
  return {
    filtered,
    sitesSiteTypeData,
    sitesSiteStatusData,
    sitesAreaHierarchyTreeData,
    sitesWorkOrderPriorityDataMap,
    equipmentsEquipmentCategoryData,
    equipmentsEquipmentTypeData
  };
};

export const filterSitesWithPromise = ({ args }) => {
  if (args.createCoordinateList && args.sites.length > 0) {
    return new Promise((resolve) => {
      const response = filterSites({ ...args });
      const sitesCoordinates = filterSiteListBasedOnCoordinates({
        filterSitesList: response?.filtered
      });
      Promise.all([response, sitesCoordinates]).then((result) => {
        let newResult = result.reduce((acc, obj) => {
          return { ...acc, ...obj };
        }, {});
        resolve(newResult);
      });
    });
  } else {
    return new Promise((resolve) => {
      const response = filterSites({ ...args });
      resolve(response);
    });
  }
};

export const tagsDataList = ['DISTANCE', '# TASKS', 'DUE'];

const dueDateSort = (prev, next) => {
  if (!prev.soonestDueDate || !next.soonestDueDate) {
    return prev.soonestDueDate ? -1 : 1;
  }

  const dateA = new Date(prev.soonestDueDate);
  const dateB = new Date(next.soonestDueDate);

  if (dateA < dateB) {
    return -1;
  } else if (dateA > dateB) {
    return 1;
  } else {
    return 0;
  }
};

export const distanceFilter = (prev, next) => {
  if (prev?.distance === null) {
    return 1;
  }

  if (next.distance === null) {
    return -1;
  }

  if (prev?.distance === next?.distance) {
    return 0;
  }

  return prev?.distance < next?.distance ? -1 : 1;
};

const tasksFilter = (prev, next) => {
  return next?.allotDoneTasks?.length - prev?.allotDoneTasks?.length;
};

const getInspectionTypeTags = (
  sites = [],
  inspectionTypesMap = {},
  inspectionFormsUserCacheTypeMap = {},
  inspectionFormsUserCacheMap = {}
) => {
  const tasks = sites.flatMap((x, i) => x.allTasksForSite);
  let inspectionTypeTags = [];

  for (let task of tasks) {
    const inspectionFormId = task?.inspectionFormId || '';
    let inspectionFormName = inspectionFormsUserCacheMap[inspectionFormId] || '';

    const original = inspectionTypesMap[task?.inspectionTypeId];
    if (
      inspectionFormName &&
      !inspectionTypeTags.some((tag) => tag.value === inspectionFormName?.name)
    ) {
      const obj = {
        ...original,
        value: inspectionFormName?.name,
        inspectionFormId: inspectionFormName?.inspectionFormId,
        key: inspectionFormName?.inspectionFormId
      };
      inspectionTypeTags.push(obj);
    }
  }

  const inspectionTypeTagsMap = inspectionTypeTags?.reduce((acc, curr) => {
    acc[curr.inspectionFormId] = { value: curr.value };
    return acc;
  }, {});

  inspectionTypeTags = sortFilterTags({
    list: inspectionTypeTags,
    isCheckField: true,
    fieldName: 'value'
  });
  return { inspectionTypeTags, inspectionTypeTagsMap };
};

const getInspectionRunTags = (sites = []) => {
  const tasks = sites.flatMap((x) => x.allTasksForSite);

  const tags = Array.from(
    new Set(
      tasks.map((task) => {
        if (task?.runNumber) return `${task?.runNumber} - ${task?.RunName?.trim()}`;
      })
    )
  ).filter((y) => y);
  return sortFilterTags({
    list: tags,
    isCheckField: false,
    fieldName: ''
  });
};

export const mapValues = (
  sitesSiteTypeDataMap,
  sitesSiteStatusDataMap,
  sitesAssignableUsersDataMap,
  sitesCheckPriorityDataMap,
  sitesWorkOrderPriorityDataMap,
  sitesAreaHierarchyTreeDataMap,
  sites,
  store,
  equipmentsEquipmentCategoryDataMap = {},
  equipmentsEquipmentTypeDataMap = {},
  filterType
) => {
  const { picklists, tasks: reduxTasks, inspection, checks, hseEvents } = store;
  const {
    siteTypeData = [],
    siteStatusData = [],
    checkPriorityData = [],
    assignableUsersData = [],
    workOrderPriorityData = [],
    areaHierarchyTreeData = [],
    picklistsMap = {},
    equipmentCategoryData = [],
    equipmentTypeData = []
  } = picklists;
  const { workOrderUsersGroupsMap = {}, tasksList } = reduxTasks;
  const { checksList, checkTypesMap } = checks;

  const {
    inspectionTypesMap = {},
    incidentCategory = {},
    incidentCategoryMap,
    inspectionFormsUserCacheTypeMap,
    inspectionFormsUserCacheMap = {}
  } = inspection;
  const { HSEEventList } = hseEvents;

  const incidentCategoryMapChange = incidentCategory?.reduce((acc, curr) => {
    acc[curr.value] = curr?.label;
    return acc;
  }, {});

  let siteTypeTags = sitesSiteTypeDataMap
    ? siteTypeData?.filter(({ key }) => sitesSiteTypeDataMap?.[key])
    : siteTypeData;

  siteTypeTags = sortFilterTags({
    list: siteTypeTags,
    isCheckField: true,
    fieldName: 'value'
  });

  let siteStatusTags = sitesSiteStatusDataMap
    ? siteStatusData?.filter(({ key }) => sitesSiteStatusDataMap[key])
    : siteStatusData;

  siteStatusTags = sortFilterTags({
    list: siteStatusTags,
    isCheckField: true,
    fieldName: 'value'
  });

  let checkPriorityTags = sitesCheckPriorityDataMap
    ? checkPriorityData.filter(({ key }) => sitesCheckPriorityDataMap[key])
    : checkPriorityData;

  checkPriorityTags = sortFilterTags({
    list: checkPriorityTags,
    isCheckField: true,
    fieldName: 'value'
  });

  let workOrderPriorityTags = sitesWorkOrderPriorityDataMap
    ? workOrderPriorityData.filter(({ key }) => sitesWorkOrderPriorityDataMap[key])
    : workOrderPriorityData;

  workOrderPriorityTags = sortFilterTags({
    list: workOrderPriorityTags,
    isCheckField: true,
    fieldName: 'value'
  });

  const treeData = sitesAreaHierarchyTreeDataMap
    ? removeUnavailableTreeData(
        JSON.parse(JSON.stringify(areaHierarchyTreeData)),
        sitesAreaHierarchyTreeDataMap
      )
    : areaHierarchyTreeData;

  const taskTypeTag = getSiteTaskTypeTags(sites);
  const taskStatusTags = getSiteTaskStatusTags(sites);
  const assignedUserGroups = getSiteTaskAssignedUserGroups(sites);
  const assignableUsersTags = getTaskAssignedToTags({
    assignedUserGroups,
    workOrderUsersGroupsMap
  });
  const { inspectionTypeTags, inspectionTypeTagsMap } = getInspectionTypeTags(
    sites,
    inspectionTypesMap,
    inspectionFormsUserCacheTypeMap,
    inspectionFormsUserCacheMap
  );
  const inspectionRunTags = getInspectionRunTags(sites);
  const taskRecurringTemplateTags = getTaskRecurringTemplateTags(sites) || [];
  const { workOrderTypeTags, workOrderTypeTagMap } =
    getWorkOrderTypeTags(sites, picklistsMap) || [];
  const hseEventsCategoriesTags = getHSEEventCategory(
    HSEEventList,
    incidentCategoryMapChange,
    inspectionTypesMap,
    incidentCategoryMap
  );
  const checkRecurrancePriorityTags = getCheckRecurrancePriorityTags(sites, picklistsMap);
  const { checkTypeTags, checkTypeTagsMap } = getCheckTypeTags(sites, checkTypesMap);

  let equipmentCategoryTags = ['NewOrEditAsset', 'newOrEditAssets'].includes(filterType)
    ? equipmentsEquipmentCategoryDataMap
      ? equipmentCategoryData.filter(({ key }) => equipmentsEquipmentCategoryDataMap[key])
      : equipmentCategoryData
    : [];

  equipmentCategoryTags = sortFilterTags({
    list: equipmentCategoryTags,
    isCheckField: true,
    fieldName: 'value'
  });

  let equipmentTypeTags = ['NewOrEditAsset', 'newOrEditAssets'].includes(filterType)
    ? equipmentsEquipmentTypeDataMap
      ? equipmentTypeData.filter(({ key }) => equipmentsEquipmentTypeDataMap[key])
      : equipmentTypeData
    : [];

  equipmentTypeTags = sortFilterTags({
    list: equipmentTypeTags,
    isCheckField: true,
    fieldName: 'value'
  });

  return {
    siteTypeTags,
    siteStatusTags,
    assignableUsersTags,
    checkPriorityTags,
    workOrderPriorityTags,
    treeData,
    taskTypeTag,
    taskStatusTags,
    inspectionTypeTags,
    inspectionRunTags,
    taskRecurringTemplateTags,
    workOrderTypeTags,
    hseEventsCategoriesTags,
    checkRecurrancePriorityTags,
    checkTypeTags,
    checkTypeTagsMap,
    inspectionTypeTagsMap,
    workOrderTypeTagMap,
    equipmentCategoryTags,
    equipmentTypeTags
  };
};

const getCheckTypeTags = (sites = [], checkTypesMap = {}) => {
  let checkTypeTags = [];

  for (let site of sites) {
    const siteTask = site?.allTasksForSite || [];
    for (let task of siteTask) {
      if (task?.type === 'Check' && checkTypesMap[task?.inspectionTypeId]) {
        if (
          checkTypesMap[task?.inspectionTypeId] &&
          !checkTypeTags.includes(checkTypesMap[task?.inspectionTypeId])
        )
          checkTypeTags.push(checkTypesMap[task?.inspectionTypeId]);
      }
    }
  }

  const checkTypeTagsMap = checkTypeTags?.reduce((acc, curr) => {
    acc[curr.key] = { value: curr.value };
    return acc;
  }, {});
  checkTypeTags = sortFilterTags({
    list: checkTypeTags,
    isCheckField: true,
    fieldName: 'value'
  });

  return { checkTypeTags, checkTypeTagsMap };
};

const getCheckRecurrancePriorityTags = (sites = [], picklistsMap) => {
  let checkRecurrenceTags = [];

  for (let site of sites) {
    const siteTask = site?.allTasksForSite || [];
    for (let task of siteTask) {
      if (
        task?.type === 'Check' &&
        task?.recurrencePriorityId &&
        picklistsMap[task?.recurrencePriorityId]
      ) {
        let recurreanceValue = picklistsMap[task?.recurrencePriorityId] || {};
        let recurreanceValueCopy = { ...recurreanceValue };
        recurreanceValueCopy.value = recurreanceValue?.value?.split(' ')[0] || '';
        if (!checkRecurrenceTags.some((tag) => tag.value === recurreanceValueCopy.value)) {
          checkRecurrenceTags.push(recurreanceValueCopy);
        }
      }
    }
  }

  checkRecurrenceTags = sortFilterTags({
    list: checkRecurrenceTags,
    isCheckField: true,
    fieldName: 'value'
  });

  return checkRecurrenceTags;
};

const getHSEEventCategory = (
  tasks = [],
  incidentCategoryMapChange = {},
  inspectionTypesMap,
  incidentCategoryMap
) => {
  let hseEventsCategoriesTags = [];
  for (let task of tasks) {
    if (task?.type === 'HSE') {
      const inspectionType = task?.incidentCategory
        ? incidentCategoryMapChange[task?.incidentCategory]
        : inspectionTypesMap[task?.HSETypeId]?.value || null;

      if (incidentCategoryMap[inspectionType] && !hseEventsCategoriesTags?.includes(inspectionType))
        hseEventsCategoriesTags.push(inspectionType);
    }
  }

  hseEventsCategoriesTags = sortFilterTags({
    list: hseEventsCategoriesTags,
    isCheckField: true,
    fieldName: 'value'
  });

  return hseEventsCategoriesTags;
};

const getWorkOrderTypeTags = (sites = [], picklistsMap = {}) => {
  let workOrderTypeTags = [];

  sites.map((item) =>
    item?.allTasksForSite?.map((task) => {
      if (picklistsMap[task?.typeId] && !workOrderTypeTags.includes(picklistsMap[task?.typeId]))
        workOrderTypeTags.push(picklistsMap[task?.typeId]);
    })
  );

  const workOrderTypeTagMap = workOrderTypeTags?.reduce((acc, curr) => {
    acc[curr.key] = { value: curr.value };
    return acc;
  }, {});

  workOrderTypeTags = sortFilterTags({
    list: workOrderTypeTags,
    isCheckField: true,
    fieldName: 'value'
  });

  return { workOrderTypeTags, workOrderTypeTagMap };
};

const getTaskRecurringTemplateTags = (sites = []) => {
  let tags = Array.from(
    new Set(
      sites
        .map(
          (item) =>
            item.allTasksForSite &&
            item.allTasksForSite.map((task) => {
              if (task.rtNumber) return `${task.rtNumber} - ${task.rtName}`;
            })
        )
        .flat()
        .filter((name) => name)
    )
  );

  tags = sortFilterTags({
    list: tags,
    isCheckField: false,
    fieldName: ''
  });

  return tags;
};

const getTaskAssignedToTags = ({ assignedUserGroups, workOrderUsersGroupsMap }) => {
  let data =
    (assignedUserGroups && // responsible users groups
      _.size(assignedUserGroups) > 0 &&
      assignedUserGroups
        .map((key) => workOrderUsersGroupsMap[key] && workOrderUsersGroupsMap[key]?.name)
        .filter((y) => y)) ||
    [];

  let assignableUsersTags = ['Me, directly', 'A group I’m in', ...data];

  return assignableUsersTags;
};

const getSiteTaskTypeTags = (sites) => {
  let taskTypeTag = [];
  for (let site of sites) {
    if (
      _.size(site.allTasksForSite) > 0 &&
      site.allTasksForSite.some((x) => x.type === 'Work Order')
    ) {
      taskTypeTag.push('Work orders');
      break;
    }
  }
  for (let site of sites) {
    if (
      _.size(site.allWorkRequestListSyncedAndInprogress) > 0 &&
      site.allWorkRequestListSyncedAndInprogress.some(
        (x) => x.type === 'Work Request' || x.newWorkRequest || x?.entityType === 'WorkRequest'
      )
    ) {
      taskTypeTag.push('Work requests');
      break;
    }
  }
  for (let site of sites) {
    if (
      _.size(site.allTasksForSite) > 0 &&
      site.allTasksForSite.some((x) => x.type === 'Inspection')
    ) {
      taskTypeTag.push('Inspections');
      break;
    }
  }
  for (let site of sites) {
    if (_.size(site.allTasksForSite) > 0 && site.allTasksForSite.some((x) => x.type === 'Check')) {
      taskTypeTag.push('Check');
      break;
    }
  }

  for (let site of sites) {
    if (_.size(site.hseEvents) > 0 && site.hseEvents.some((x) => x.type === 'HSE')) {
      taskTypeTag.push('HSE events');
      break;
    }
  }

  for (let site of sites) {
    if (
      _.size(site?.equipmentEditList) > 0 &&
      site.equipmentEditList.some((x) => x.type === 'New or edited asset')
    ) {
      taskTypeTag.push('New or edited asset');
      break;
    }
  }

  return taskTypeTag?.length > 0 ? [...taskTypeTag, 'All'] : taskTypeTag;
};
const getSiteTaskStatusTags = (sites) => {
  let taskStatusTags = [];
  for (let site of sites) {
    if (
      (_.size(site.allTasksForSite) > 0 &&
        site.allTasksForSite.some((x) => x.status === 'To do')) ||
      (_.size(site.allWorkRequestListSyncedAndInprogress) > 0 &&
        site.allWorkRequestListSyncedAndInprogress.some((x) => x.status === 'To do')) ||
      (_.size(site?.equipmentEditList) > 0 &&
        site?.equipmentEditList.some((x) => x.equipmentEditingStatus === 'To do'))
    ) {
      taskStatusTags.push('To do');
      break;
    }
  }

  for (let site of sites) {
    if (
      (_.size(site.allTasksForSite) > 0 &&
        site.allTasksForSite.some((x) => x.status === 'In progress')) ||
      (_.size(site.allWorkRequestListSyncedAndInprogress) > 0 &&
        site.allWorkRequestListSyncedAndInprogress.some((x) => x.status === 'In progress')) ||
      (_.size(site?.equipmentEditList) > 0 &&
        site?.equipmentEditList.some((x) => x.equipmentEditingStatus === 'In progress'))
    ) {
      taskStatusTags.push('In progress');
      break;
    }
  }
  for (let site of sites) {
    if (
      (_.size(site.allTasksForSite) > 0 &&
        site.allTasksForSite.some((x) => x.status === 'Pending sync')) ||
      (_.size(site.allWorkRequestListSyncedAndInprogress) > 0 &&
        site.allWorkRequestListSyncedAndInprogress.some((x) => x.status === 'Pending sync')) ||
      (_.size(site?.equipmentEditList) > 0 &&
        site?.equipmentEditList.some((x) => x.equipmentEditingStatus === 'Pending sync'))
    ) {
      taskStatusTags.push('Pending sync');
      break;
    }
  }
  for (let site of sites) {
    if (
      (_.size(site.allTasksForSite) > 0 &&
        site.allTasksForSite.some((x) => x.status === 'Synced')) ||
      (_.size(site.allWorkRequestListSyncedAndInprogress) > 0 &&
        site.allWorkRequestListSyncedAndInprogress.some((x) => x.status === 'Synced')) ||
      (_.size(site?.equipmentEditList) > 0 &&
        site?.equipmentEditList.some((x) => x.equipmentEditingStatus === 'Synced'))
    ) {
      taskStatusTags.push('Synced');
      break;
    }
  }
  return taskStatusTags;
};

const getSiteTaskAssignedUserGroups = (sites) => {
  let assignedUserGroups = [];
  for (let site of sites) {
    if (_.size(site.allTasksForSite) > 0) {
      assignedUserGroups.push(
        Array.from(new Set(site.allTasksForSite.map((t) => t?.responsibleUserGroups).flat(2))) || []
      );
    }
  }
  return Array.from(new Set(_.flattenDeep(assignedUserGroups))) || [];
};

export const countFilters = (filters, inputValue, store) => {
  let count = 0;
  const { picklists } = store;

  const {
    proximity,
    area,
    siteType,
    siteStatus,
    taskType,
    taskStatus,
    assign,
    priority,
    workOrderPriority,
    workOrderType = { value: [] },
    recurringTemplate = { value: [] },
    checkRecurrancePriority = { value: [] },
    inspectionType = { value: [] },
    checkType = { value: [] },
    equipmentCategory = {
      value: []
    },
    equipmentType = {
      value: []
    }
  } = filters;

  if (inputValue?.trim()) ++count;
  if (proximity.value > 0) ++count;
  if (workOrderType?.value?.length > 0) ++count;
  if (assign?.value?.length > 0) ++count;
  if (siteType?.value?.length > 0) ++count;
  if (taskType?.value?.length > 0) ++count;
  if (taskStatus?.value?.length > 0) ++count;
  if (siteStatus?.value?.length > 0) ++count;
  if (checkType?.value?.length > 0) ++count;
  if (recurringTemplate?.value?.length > 0) ++count;

  if (checkRecurrancePriority?.value.length > 0) ++count;
  if (inspectionType?.value?.length > 0) ++count;

  if (equipmentCategory?.value?.length > 0) ++count;
  if (equipmentType?.value?.length > 0) ++count;

  if (priority?.value?.length > 0 || workOrderPriority?.value?.length > 0) ++count;
  if (
    area?.value &&
    area?.value.filter((el) => picklists.areaHierarchyTreeDataMap?.[el])?.length > 0
  )
    ++count;

  ['dueDate', 'scheduledDate', 'createdAt', 'syncedDate'].forEach((key) => {
    const { value, selected } = filters[key] || { value: '', selected: '' };
    if (
      selected &&
      !_.isEmpty(value) &&
      (selected === 'on'
        ? value
        : selected === 'range'
        ? value?.[0] !== '' && value?.[1] !== ''
        : value?.length > 0)
    )
      ++count;
  });
  return count;
};

export const getSiteFilterDefaultValues = {
  proximity: { value: 0 },
  area: { value: [] },
  siteType: { value: [] },
  siteStatus: { value: [] },
  lastSiteCheckIn: { value: [], selected: 'past' },
  taskType: { value: [] },
  taskStatus: { value: [] },
  assign: { value: [] },
  priority: { value: [] },
  workOrderPriority: { value: [] },
  download: { value: '', selected: 'past' },
  createdAt: { value: '', selected: 'past' },
  syncedDate: { value: '', selected: 'past' },
  dueDate: { value: [], selected: 'next' },
  scheduledDate: { value: [], selected: 'next' },
  recurringTemplate: { value: [] },
  workOrderType: { value: [] },
  inspectionType: { value: [] },
  inspectionRun: { value: [] },
  checkRecurrancePriority: { value: [] },
  checkType: { value: [] }
};

export const filterSiteListBasedOnCoordinates = ({ filterSitesList }) => {
  return new Promise((resolve) => {
    let copyFilterSitesList = [...filterSitesList];

    let coordinatesList = [];
    copyFilterSitesList = copyFilterSitesList?.filter((filterDistanceSite) => {
      const distance = filterDistanceSite?.distance || 0;

      const siteWithNoTask = filterDistanceSite?.allTasksForSite?.length === 0 ? true : false;

      const siteWithAllTaskCompleted =
        filterDistanceSite?.allTasksForSite?.length === filterDistanceSite?.allDoneTasks?.length
          ? true
          : false;

      const siteWithSomeTaskIsCompleted =
        filterDistanceSite?.allTasksForSite?.length > 0 &&
        filterDistanceSite?.allDoneTasks?.length > 0 &&
        filterDistanceSite?.allTasksForSite?.length !== filterDistanceSite?.allDoneTasks?.length
          ? true
          : false;

      const siteWithNoTaskIsCompleted =
        filterDistanceSite?.allTasksForSite?.length > 0 &&
        filterDistanceSite?.allDoneTasks?.length == 0
          ? true
          : false;

      const iconName = siteWithNoTask
        ? 'no-task-pin'
        : siteWithAllTaskCompleted
        ? 'all-task-completed-pin'
        : siteWithSomeTaskIsCompleted
        ? 'some-task-completed'
        : siteWithNoTaskIsCompleted
        ? 'no-task-completed'
        : null;
      const selectedIconName = siteWithNoTask
        ? 'no-task-selected-pin'
        : siteWithAllTaskCompleted
        ? 'all-task-completed-selected-pin'
        : siteWithSomeTaskIsCompleted
        ? 'some-task-completed-selected-pin'
        : siteWithNoTaskIsCompleted
        ? 'no-task-completed-selected-pin'
        : null;

      parseFloat(distance) > 0 &&
        coordinatesList.push({
          siteId: filterDistanceSite.siteId,
          latitude: filterDistanceSite?.latitude || 0,
          longitude: filterDistanceSite?.longitude || 0,
          selectedIconName,
          iconName,
          totalTask: filterDistanceSite?.allTasksForSite?.length || 0,
          default: filterDistanceSite?.default || false
        });
      return parseFloat(distance) > 0 ? true : false;
    });

    resolve({
      allSiteCoordinatesList: coordinatesList
    });
  });
};

export const sortMapSiteList = ({
  copyFilterSitesList,
  selectedSiteIdForMapView,
  SelectedFilter
}) => {
  const newList = copyFilterSitesList
    .filter((i) => i.siteId !== selectedSiteIdForMapView?.siteId)
    .sort((a, b) => {
      switch (SelectedFilter[0]) {
        case 'DUE':
          return dueDateSort(a, b);
        case 'DISTANCE':
          return distanceFilter(a, b);
        case 'A-Z':
          return a.name.localeCompare(b.name);
        case '# TASKS':
          return tasksFilter(a, b);
      }
    });
  return newList;
};

export const sortMapSiteList1 = ({ copyFilterSitesList, SelectedFilter }) => {
  const newList = copyFilterSitesList.sort((a, b) => {
    switch (SelectedFilter[0]) {
      case 'DUE':
        return dueDateSort(a, b);
      case 'DISTANCE':
        return distanceFilter(a, b);
      case 'A-Z':
        return a.name.localeCompare(b.name);
      case '# TASKS':
        return tasksFilter(a, b);
    }
  });
  return newList;
};
